import { render, staticRenderFns } from "./AccountPage.vue?vue&type=template&id=901bb052&scoped=true&"
import script from "./AccountPage.vue?vue&type=script&lang=js&"
export * from "./AccountPage.vue?vue&type=script&lang=js&"
import style0 from "./AccountPage.vue?vue&type=style&index=0&id=901bb052&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "901bb052",
  null
  
)

export default component.exports